import { render, staticRenderFns } from "./DonationLayout.vue?vue&type=template&id=33671cb4"
import script from "./DonationLayout.vue?vue&type=script&lang=js"
export * from "./DonationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports